import React from 'react';
import cn from 'classnames';
// import { NavLink } from 'react-router-dom';

import Styles from './LeftSideBar.module.scss';
import MenuItem from './MenuItem';
import { Link } from 'react-router-dom';

export type LogoType = {
	// ToDo: make it as react.node
	image: string;
	icon?: string;
	url?: string;
};

export type LeftSideBarPropsType = {
	logo?: LogoType;
	bottomNodes?: Array<React.ReactElement<typeof MenuItem>|null>;
	classNames?: Array<string> | string |void ;
};

const LeftSideBar: React.FC<LeftSideBarPropsType> = ({
	bottomNodes,
	children,
	logo,
	classNames,
}) => {
	const getClassNames = (): string => {
		if (classNames) {
			if (typeof classNames === 'string') {
				return classNames;
			} else {
				return classNames.length ? classNames.join(' ') : '';
			}
		}
		return '';
	};

	const getLogo = (): React.ReactNode => {
		if (logo?.image) {
			const { image, icon, url } = logo;
			return (
				<Link to={url || ''} className={cn('nav-link1', Styles.logoContainer)}>
					{Boolean(icon) && (
						<img
							className={Styles.logoIcon}
							alt="icon"
							src={icon}
						/>
					)}
					<img className={Styles.logoImage} alt="" src={image} />
				</Link>
			);
		}
		return null;
	};

	return (
		<ul
			className={cn(
				'bg-gradient-hexa sidebar sidebar-light accordion',
				Styles.menuContainer,
				getClassNames()
			)}
			id="collapseMenu"
		>
			{getLogo()}
			<div className={Styles.topContainer}>{children}</div>
			{bottomNodes && (
				<div className={'Container'}>
					<hr
						className="sidebar-divider my-0"
						style={{ margin: '0', paddingBottom:'8px' }}
					/>
                    {bottomNodes}
				</div>
			)}
		</ul>
	);
};

export default LeftSideBar;
